import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ieltsPath } from "./ieltsMocks";
import { FaPenAlt, FaExclamationCircle } from "react-icons/fa";

function WritingTestReady({ mock = 1 }) {
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleStartTest = () => {
        navigate(ieltsPath(mock, "writing"));
    };

    const conditions = [
        "2 writing tasks to complete in 60 minutes.",
        "Task 1: Describe visual information (20 minutes).",
        "Task 2: Essay writing (40 minutes).",
        "Word count monitoring enabled.",
        "Spell check and grammar suggestions disabled.",
        "Auto-submit when time expires.",
    ];

    const details = [
        { number: "60", label: "Minutes Total" },
        { number: "2", label: "Tasks" },
        { number: "300", label: "Min Words" },
        { number: "9.0", label: "Max Band" },
    ];

    const tasks = [
        {
            title: "Task 1: Academic/General Training",
            points: [
                "Describe visual information (chart, graph, diagram).",
                "Minimum 150 words.",
                "Recommended time: 20 minutes.",
            ],
        },
        {
            title: "Task 2: Essay Writing",
            points: [
                "Respond to a point of view, argument, or problem.",
                "Minimum 250 words.",
                "Recommended time: 40 minutes.",
            ],
        },
    ];

    return (
        <>
            <style>{`
                .writing-container {
                    min-height: 100vh;
                    background: #fafafa;
                    padding: 2rem;
                    padding-top: 96px;
                    display: flex;
                    align-items: flex-start;
                    justify-content: center;
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                }

                .content-wrapper {
                    width: 100%;
                    max-width: 720px;
                    background: #ffffff;
                    border-radius: 20px;
                    padding: 3rem 3.25rem;
                    border: 1px solid #e8e8e8;
                    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.07);
                }

                .icon-badge {
                    width: 68px;
                    height: 68px;
                    border-radius: 16px;
                    background: rgba(10, 137, 78, 0.08);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 1.5rem auto;
                }

                .icon-badge svg {
                    font-size: 1.9rem;
                    color: #0a894e;
                }

                .main-title {
                    font-size: 2.1rem;
                    font-weight: 800;
                    margin: 0 0 0.35rem 0;
                    color: #0a894e;
                    text-align: center;
                    letter-spacing: -0.01em;
                }

                .exam-title {
                    text-align: center;
                    color: #15803d;
                    font-size: 1rem;
                    font-weight: 700;
                    margin-bottom: 0.4rem;
                }

                .subtitle {
                    font-size: 1.05rem;
                    color: #666;
                    text-align: center;
                    margin-bottom: 2.25rem;
                }

                .section-title {
                    font-size: 0.85rem;
                    font-weight: 700;
                    color: #0a894e;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    margin: 0 0 1rem 0;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                }

                .section-title svg {
                    font-size: 1rem;
                }

                .conditions-box {
                    background: #f7f8f7;
                    border-radius: 14px;
                    padding: 0.25rem 1.5rem;
                    border: 1px solid #e5e5e5;
                    margin-bottom: 2rem;
                }

                .conditions-list {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }

                .condition-item {
                    color: #333;
                    padding: 1rem 0;
                    font-size: 1rem;
                    border-bottom: 1px solid #e8e8e8;
                    display: flex;
                    align-items: flex-start;
                    line-height: 1.45;
                }

                .condition-item:last-child {
                    border-bottom: none;
                }

                .condition-item::before {
                    content: "";
                    min-width: 7px;
                    height: 7px;
                    border-radius: 50%;
                    background: #0a894e;
                    margin-right: 0.9rem;
                    margin-top: 0.5rem;
                }

                .test-details {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 0.85rem;
                    margin-bottom: 2rem;
                }

                .detail-card {
                    background: #f7f8f7;
                    border-radius: 12px;
                    padding: 1rem 0.5rem;
                    border: 1px solid #e5e5e5;
                    text-align: center;
                    transition: all 0.2s ease;
                }

                .detail-card:hover {
                    transform: translateY(-2px);
                    border-color: #0a894e;
                }

                .detail-number {
                    font-size: 1.5rem;
                    font-weight: 800;
                    color: #0a894e;
                    margin-bottom: 0.15rem;
                }

                .detail-label {
                    color: #777;
                    font-size: 0.74rem;
                    font-weight: 600;
                }

                .tasks-section {
                    background: #f7f8f7;
                    border-radius: 14px;
                    padding: 1.5rem 1.75rem;
                    margin-bottom: 2rem;
                    border: 1px solid #e5e5e5;
                }

                .task-item {
                    margin-bottom: 1.25rem;
                }

                .task-item:last-of-type {
                    margin-bottom: 0;
                }

                .task-title {
                    color: #0a894e;
                    font-size: 1rem;
                    margin-bottom: 0.5rem;
                    font-weight: 700;
                }

                .task-details {
                    color: #444;
                    margin: 0.3rem 0;
                    font-size: 0.92rem;
                    display: flex;
                    align-items: flex-start;
                    line-height: 1.4;
                }

                .task-details::before {
                    content: "▸";
                    color: #0a894e;
                    margin-right: 0.6rem;
                    font-weight: bold;
                }

                .word-count-info {
                    background: #ecfdf5;
                    border-radius: 10px;
                    padding: 0.8rem;
                    margin-top: 1.25rem;
                    text-align: center;
                    border: 1px solid #bbf7d0;
                }

                .word-count-text {
                    color: #374151;
                    font-size: 0.92rem;
                }

                .word-count-highlight {
                    color: #0a894e;
                    font-weight: 700;
                }

                .button-group {
                    display: flex;
                    gap: 1rem;
                    justify-content: center;
                }

                .start-button {
                    flex: 1;
                    background: #0a894e;
                    color: #fff;
                    border: none;
                    padding: 1.05rem 1.75rem;
                    font-size: 1.05rem;
                    font-weight: 600;
                    border-radius: 12px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 0.7rem;
                    transition: all 0.2s ease;
                }

                .start-button:hover {
                    background: #087a44;
                    transform: translateY(-2px);
                    box-shadow: 0 8px 18px rgba(10, 137, 78, 0.28);
                }

                .exit-button {
                    flex: 1;
                    background: transparent;
                    color: #444;
                    border: 1px solid #d8d8d8;
                    padding: 1.05rem 1.75rem;
                    font-size: 1.05rem;
                    font-weight: 600;
                    border-radius: 12px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .exit-button:hover {
                    background: #f5f5f5;
                    border-color: #bbb;
                    transform: translateY(-2px);
                }

                .pen-icon {
                    font-size: 0.95rem;
                }

                /* Responsive Design */
                @media (max-width: 760px) {
                    .content-wrapper {
                        max-width: 100%;
                        padding: 2.25rem 1.75rem;
                    }
                }

                @media (max-width: 560px) {
                    .writing-container {
                        padding: 1rem;
                        padding-top: 76px;
                    }

                    .content-wrapper {
                        padding: 1.75rem 1.5rem;
                        border-radius: 16px;
                    }

                    .main-title {
                        font-size: 1.6rem;
                    }

                    .subtitle {
                        font-size: 0.95rem;
                    }

                    .condition-item {
                        font-size: 0.92rem;
                    }

                    .test-details {
                        grid-template-columns: repeat(2, 1fr);
                    }

                    .button-group {
                        flex-direction: column;
                    }
                }
            `}</style>

            <div className="writing-container">
                <div className="content-wrapper">
                    <div className="icon-badge">
                        <FaPenAlt />
                    </div>

                    <h1 className="main-title">Writing Test Ready</h1>
                    <h2 className="exam-title">IELTS Academic Writing</h2>
                    <p className="subtitle">
                        Prepare for your IELTS {mock === 1 ? "" : `Mock ${mock} `}Writing assessment.
                    </p>

                    <h2 className="section-title">
                        <FaExclamationCircle />
                        Exam Conditions Active
                    </h2>

                    <div className="conditions-box">
                        <ul className="conditions-list">
                            {conditions.map((condition, index) => (
                                <li className="condition-item" key={index}>
                                    {condition}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="test-details">
                        {details.map((detail, index) => (
                            <div className="detail-card" key={index}>
                                <div className="detail-number">
                                    {detail.number}
                                </div>
                                <div className="detail-label">
                                    {detail.label}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="tasks-section">
                        {tasks.map((task, index) => (
                            <div className="task-item" key={index}>
                                <div className="task-title">
                                    {task.title}
                                </div>

                                {task.points.map((point, pIndex) => (
                                    <div
                                        className="task-details"
                                        key={pIndex}
                                    >
                                        {point}
                                    </div>
                                ))}
                            </div>
                        ))}

                        <div className="word-count-info">
                            <span className="word-count-text">
                                Total minimum words:{" "}
                                <span className="word-count-highlight">
                                    300+
                                </span>
                            </span>
                        </div>
                    </div>

                    <div className="button-group">
                        <button
                            className="start-button"
                            onClick={handleStartTest}
                        >
                            <FaPenAlt className="pen-icon" />
                            <span>Start Test</span>
                        </button>

                        <button
                            className="exit-button"
                            onClick={() => navigate("/")}
                        >
                            Exit Module
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default WritingTestReady;